// Func = limiting Scope for this file

(function(){

	// animation hover fin a table
	setTimeout(() => {
		let input = document.querySelector('.ot-dtp-picker-button')
		if (input) {
			input = input.cloneNode(true)
			let newNode = input.outerHTML.replace('input', 'button')
			let form = document.querySelector('.ot-dtp-picker-form')
			newNode = newNode + 'Find a table <span class="mask-copy">Find a table</span></button>'
			console.log(newNode);
			form.insertAdjacentHTML("beforeend", newNode)
		}
	}, 2000);

	//booking widget
	const fullbooking = document.querySelector('.booking-holder');
	const bookingWidget = {
		bookingOpen: document.querySelector('.booking-trig-js'),
		bookingClose: document.querySelector('.close-booking-js')
	};

	if(fullbooking) { 
		bookingWidget.bookingOpen.addEventListener('click', function () {
			fullbooking.classList.add('expanded');
		});
		bookingWidget.bookingClose.addEventListener('click', function () {
			fullbooking.classList.remove('expanded');
		});
	}

	//full navigation
    const fullnav = document.querySelector('.header__nav-holder'); 
    const primaryNav = { 
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };

    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
            document.querySelector('.header__logo').classList.add('white');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
            document.querySelector('.header__logo').classList.remove('white');
        });
    }

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});


	$(document).ready(function () {  


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//reasons rotator
		$('.slider h2 span').wrap('<span class="header-mask"></span>');

		$('.small-gallery__rotator').slick({
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			prevArrow: $('.small-gallery__prev-slide'),
    		nextArrow: $('.small-gallery__next-slide'),
			accessibility: false
		});
	});


}());
